import {createLifecycleActions, createRecordActions, createGmailActions} from './dataActions';
import {createModelActions, createTicketActions} from './aiActions';
import type {ActionContext, WorkspaceActions} from './types';

export function createWorkspaceActions(context: ActionContext): WorkspaceActions {
  const lifecycle = createLifecycleActions(context);
  return {...lifecycle, ...createRecordActions(context), ...createGmailActions(context),
    ...createModelActions(context), ...createTicketActions(context, lifecycle.refresh)};
}